import { render, staticRenderFns } from "./expertise.vue?vue&type=template&id=6a9f89a4&scoped=true&"
import script from "./expertise.ts?vue&type=script&lang=ts&"
export * from "./expertise.ts?vue&type=script&lang=ts&"
import style0 from "./expertise.styl?vue&type=style&index=0&id=6a9f89a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9f89a4",
  null
  
)

export default component.exports